<template>
 <div>
   <div class="form-box">
      <div class="form">
    <el-form label-position="right" label-width="100px" :model="form" ref="formRef">
  <el-form-item label="Protein :" prop="protein">
    <el-input v-model="form.protein"></el-input>
  </el-form-item>
  <el-form-item label="Gene :" prop="gene">
    <el-input v-model="form.gene"></el-input>
  </el-form-item>
  <el-form-item label="Metal:" prop="metal">
    <el-input v-model="form.metal"></el-input>
  </el-form-item>
  <el-form-item label="Organism:" prop="org">
    <el-input v-model="form.org"></el-input>
  </el-form-item>
  <el-form-item label="Taxonomy:" prop="tax">
    <el-input v-model="form.tax"></el-input>
  </el-form-item>
  <el-form-item label="EC Number:" prop="ec">
    <el-input v-model="form.ec"></el-input>
  </el-form-item>
  <el-form-item label="Uniprot ID:" prop="accession">
    <el-input v-model="form.accession"></el-input>
  </el-form-item>
  <el-form-item label="PDB ID:" prop="pdb">
    <el-input v-model="form.pdb"></el-input>
  </el-form-item>
  <el-form-item class="btns">
          <el-button type="primary" @click="Submit" >Search</el-button>
          <el-button type="info" @click="formreset">Reset</el-button>
        </el-form-item>
</el-form>
  </div>
  <div class="label">
    <p style="margin-top:-8px"></p>
<a href="#" @click.prevent="protein">Coagulation factor IX</a>
<p style="margin-bottom: 37px;"></p>
<a href="#" @click.prevent="gene">F9</a>
<p style="margin-top:37px;"></p>
<a href="#" @click.prevent="metal">Ca</a>
<p style="margin-top:37px;"></p>
<a href="#" @click.prevent="name">Bovine</a>
<p style="margin-top:37px;"></p>
<a href="#" @click.prevent="tax">9913</a>
<p style="margin-top:37px;"></p>
<a href="#" @click.prevent="ec">3.4.21.22</a>
<p style="margin-top:37px;"></p>
<a href="#" @click.prevent="accession">P00741</a>
<p style="margin-top:37px;"></p>
<a href="#" @click.prevent="pdb">1j35</a>
  </div>
   </div>
  
  <div class="datatable" v-if="flag">
    <hr/>
    <!--显示内容-->
      <hr />
      <!--列表区-->
     <el-table
        :data="datalist"
        :row-key="getRowKey"
        border
        stripe
      >
        <el-table-column
          type="index"
          :index="(form.page-1)*(form.page_size)+1"
          :resizable="false"
          label="#"
        ></el-table-column>
        <el-table-column label="Accession" prop="accession">
          <template slot-scope="scope">
            <a
              :href="['@/../#/content/?accession='+scope.row.accession]"
              style="text-decoration:none;"
            >{{scope.row.accession}}</a>
          </template>
        </el-table-column>
        <el-table-column label="Protein" prop="protein"></el-table-column>
          <el-table-column label="Gene(s)" prop="gene"></el-table-column>
          <el-table-column label="Organism" prop="organism">
            <template slot-scope="scope">
            <a
            :href="[ 'https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=' + scope.row.tax_id,]"
              style="text-decoration:none;"
            >{{scope.row.organism}}</a>
          </template>
          </el-table-column>
          <el-table-column label="Common Name" prop="commonname"></el-table-column>
        <el-table-column label="Cofactor(s)" prop="symbol">
           <template slot-scope="scope">
            <el-button v-for="item in val(scope.row.symbol)" :key="item.id" type="primary" plain>{{item}}</el-button>
          </template></el-table-column> 
        <el-table-column label="PDB_site" prop="pdb"></el-table-column>
        <el-table-column label="EC Number" prop="ec"></el-table-column>
        <el-table-column label="3D View" prop="accession">
          <template slot-scope="scope">
            <a :href="['http://bioinfor.imu.edu.cn/mbpa/swiper/index.html?accession='+scope.row.accession]" target="_blank" style="text-decoration:none;">
            <el-button type="primary" icon="el-icon-thumb" plain>Click</el-button></a>
          </template>
        </el-table-column>
      </el-table>
      <hr />
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="form.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <hr />
  </div>
 </div>
</template>

<script>
  export default {
    data() {
      //
      return {
       form: {
          gene: '',
          protein: '',
          accession: '',
          ec:'',
          pdb:'',
          metal:'',
          tax:'',
          org:'',
          page_size: 10,
          page: 1,
        },
        total: null,
         multipleSelection: [],
      datalist: [],
        flag:false,
      };
    },//
    
    //
    methods:{
      //
      formreset(){
    this.$refs.formRef.resetFields()
},
//
protein(){
  this.form.protein="Coagulation factor IX";
},
gene(){
  this.form.gene="F9";
},
metal(){
  this.form.metal="Ca";
},
name(){
  this.form.org="Bovine";
},
tax(){
  this.form.tax="9913";
},
ec(){
  this.form.ec="3.4.21.22";
},
accession(){
  this.form.accession="P00741";
},
pdb(){
  this.form.pdb="1j35";
},
//
async Submit() {
      const res = await this.$http.get("ferrets", { params: this.form});
      if (res.status !== 200) {
        return this.$message.error("获取数据列表失败");
      }
      this.datalist = res.data.results;
      this.total = res.data.count;
      this.flag=true;
    },
//
//处理后端字符串
     val(str){
    var res = eval(str);
     return res;
   },
   
   //
   //监听每页显示变化
    handleSizeChange(newPage_size) {
      this.form.page_size = newPage_size;
      this.Submit();
    },
    //
   
    //监听当前页变化
    handleCurrentChange(newPage) {
      this.form.page = newPage;
      this.Submit();
    },
    getRowKey(row) {
      return row.id;
    },
    handleSelectionChange(val) {
      var newList = [];
      val.forEach((obj) => {
        newList.push(obj.accession);
      });
      this.multipleSelection = newList;
    },
   // 
    }
  }
</script>
<style lang="less" scoped>
.form-box{
  width:960px;
  margin-top:70px;
  margin: auto;
   display: flex;
   flex-direction: row;
}
.form{
  width:700px;
  margin-top:70px;
}
.label{
width:260px;
  margin-top:70px;
 // background-color: grey;
  a{
    font-size: 19px;
    margin-top: 52px;
    margin-left: 30px;
    text-decoration: none;
    color:rgb(40, 98, 221) ;
  }
  
}
.el-pagination {
  display: flex;
  justify-content: center;
}
</style>